/* tslint:disable */
import {
  CompanyAccount
} from '../index';

declare var Object: any;
export interface BankingInterface {
  "bank_account_name": string;
  "bank_account_number"?: string;
  "account_notes"?: string;
  "account_type"?: string;
  "account_country"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  companyAccounts?: CompanyAccount[];
}

export class Banking implements BankingInterface {
  "bank_account_name": string;
  "bank_account_number": string;
  "account_notes": string;
  "account_type": string;
  "account_country": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  companyAccounts: CompanyAccount[];
  constructor(data?: BankingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Banking`.
   */
  public static getModelName() {
    return "Banking";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Banking for dynamic purposes.
  **/
  public static factory(data: BankingInterface): Banking{
    return new Banking(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Banking',
      plural: 'Bankings',
      path: 'Bankings',
      idName: 'id',
      properties: {
        "bank_account_name": {
          name: 'bank_account_name',
          type: 'string'
        },
        "bank_account_number": {
          name: 'bank_account_number',
          type: 'string'
        },
        "account_notes": {
          name: 'account_notes',
          type: 'string'
        },
        "account_type": {
          name: 'account_type',
          type: 'string'
        },
        "account_country": {
          name: 'account_country',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        companyAccounts: {
          name: 'companyAccounts',
          type: 'CompanyAccount[]',
          model: 'CompanyAccount',
          relationType: 'hasMany',
          modelThrough: 'PropertyBank',
          keyThrough: 'bank_id',
          keyFrom: 'id',
          keyTo: 'property_id'
        },
      }
    }
  }
}
